import { render, staticRenderFns } from "./DepartureTransferGroups.vue?vue&type=template&id=41ac1c38"
import script from "./DepartureTransferGroups.vue?vue&type=script&lang=js"
export * from "./DepartureTransferGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports